var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tv-top"}},[_c('span',{on:{"click":function($event){_vm.showMarket = !_vm.showMarket}}},[_vm._v(_vm._s(_vm.rightName)+"/"+_vm._s(_vm.leftName))]),_vm._v(" "),(_vm.showMarket)?_c('div',{staticClass:"market-box"},[_c('deal-market')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f6137b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/dealTop.vue
// module id = null
// module chunks = 